<p>
  Welcome {{profile?.profilePhoto}}!
</p>
